export const DISPLAY_NONE = 'none0';
export const DISPLAY_OWNER = 'owner0';
export const DISPLAY_MINERALS = 'minerals0';

export default [{
    name: 'None',
    value: 'none0'
}, {
    name: 'Owner control level',
    value: 'owner0'
// }, {
//     name: 'Claimable',
//     value: 'claim0'
}, {
    name: 'Minerals',
    value: 'minerals0'
// }, {
//     name: 'Power enabled',
//     value: 'power0'
// }, {
//     name: 'Control points',
//     value: 'energyControl',
//     interval: true
// }, {
//     name: 'Energy harvested',
//     value: 'energyHarvested',
//     interval: true
// }, {
//     name: 'Energy spent on construction',
//     value: 'energyConstruction',
//     interval: true
// }, {
//     name: 'Energy spent on creeps',
//     value: 'energyCreeps',
//     interval: true
// }, {
//     name: 'Creeps produced',
//     value: 'creepsProduced',
//     interval: true
// }, {
//     name: 'Creeps lost',
//     value: 'creepsLost',
//     interval: true
// }, {
//     name: 'Power processed',
//     value: 'powerProcessed',
//     interval: true
}];
